import React, { useMemo } from 'react'
import Editor from '../../../components/translatedEntitiesEditor'
import {
  Select,
} from  '../../../components'
import { required } from '../../../common/validators'

const AdditionalField = ({ model: itemModel, additionalEntities: units, types, defaultLocale }) => {

  const { select, values } = itemModel
  const currentType = useMemo(() => types.find(type => type.id === values.typeId), [types, values.typeId])

  const unitsList = useMemo(() => units.map(
    unit => ({
      id: unit.id,
      name: unit.displayName[defaultLocale],
    }),
  ), [units, defaultLocale])

  const shouldShow = currentType && currentType.name === 'scale'

  return (<Select {...{
    name: 'values.unitId',
    select,
    title: 'Unit',
    values: unitsList,
    validate: shouldShow ? required : null,
    style: shouldShow ? null : { display: 'none' },
  }}
  />)
}

export default ({ entityName }) => (
  <Editor
    entityName="appliance" withImage imageRequired noStretch type="applianceType"
    additionalEntity="unit"
    additionalField={AdditionalField}
  />
)
